import * as React from "react";
const SvgQuestionFilled = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM5.83 4.483C6.286 3.872 7.05 3.5 8 3.5c.857 0 1.598.2 2.144.617A2.14 2.14 0 0 1 11 5.85c0 .565-.24 1.014-.518 1.357-.267.33-.608.61-.88.834-.3.246-.52.429-.679.615-.148.174-.173.276-.173.344a.75.75 0 0 1-1.5 0c0-.557.256-.993.53-1.315.248-.292.564-.552.82-.762l.049-.04c.29-.24.511-.427.666-.619.144-.178.185-.304.185-.414 0-.222-.083-.4-.269-.542C9.027 5.15 8.643 5 8 5c-.55 0-.836.203-.968.38a.598.598 0 0 0-.089.584.75.75 0 0 1-1.387.572 2.098 2.098 0 0 1 .274-2.053Zm3.045 7.392a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z"
      fill="#AEAFBD"
    />
  </svg>
);
export default SvgQuestionFilled;
